import './styles/StudyProgramsDetails.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';

import Card from '../../commonComponents/Card/Card';
import ConfirmDeletion from '../../commonComponents/Modals/ConfirmDeletion/ConfirmDeletion';
import { VALID_RANKS } from '../../constants/examConstants';
import addAbilityToOpenModal from '../../utilities/modalHOC';
import { canPerformAction } from '../../utilities/permissionUtils';

class StudyProgramsDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      shortname: '',
      description: '',
      type: 'rate',
      isDisabled: false,
      isAvailableForDailyQuiz: false,
      isPfeOnly: false,
      hasPassword: false,
      password: null,
      e5_regular: false,
      e6_regular: false,
    };
  }

  componentWillReceiveProps({ selectedSP }) {
    if (
      (selectedSP && selectedSP.id !== this.props.selectedSP.id) ||
      selectedSP.type !== this.props.selectedSP.type
    ) {
      if (selectedSP.id) {
        selectedSP.hasPassword = selectedSP.password;
        this.setState(selectedSP);
      } else {
        this.setState({
          name: '',
          shortname: '',
          description: '',
          type: selectedSP.type,
          isDisabled: false,
          isAvailableForDailyQuiz: !!selectedSP.isAvailableForDailyQuiz,
          id: null,
          hasPassword: false,
          password: null,
          e5_regular: false,
          e6_regular: false,
        });
      }
    }
  }

  renderContent = () => {
    const isRate = this.props.selectedSP.type === 'rate';

    return (
      <Row className="cardContentWrapper" style={{ display: 'block' }}>
        <div className="form-group row">
          <div className="col-md-12">
            <input
              className="form-control"
              placeholder="Name"
              value={this.state.name}
              onChange={(e) => this.setState({ name: e.target.value })}
            />
          </div>
        </div>
        {isRate || this.props.selectedSP.shortname ? (
          <div className="form-group row">
            <div className="col-md-12">
              <input
                className="form-control"
                placeholder="Short name"
                value={this.state.shortname}
                onChange={(e) => this.setState({ shortname: e.target.value })}
              />
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="form-group row">
          <div className="col-md-12">
            <input
              className="form-control"
              placeholder="Description"
              value={this.state.description}
              onChange={(e) => this.setState({ description: e.target.value })}
            />
          </div>
        </div>
        <div className="form-group row mt-10">
          <div className="col-md-12">
            <input
              type="checkbox"
              value="isDisabled"
              name="isDisabled"
              checked={this.state.isDisabled}
              onChange={() => {
                this.setState({ isDisabled: !this.state.isDisabled });
              }}
            />
            <label className="checkbox-inline ml-10">Disabled</label>
          </div>
          {!isRate ? (
            <div className="col-md-12">
              <input
                type="checkbox"
                name="isAvailableForQuiz"
                checked={!this.state.isAvailableForDailyQuiz}
                onChange={() => {
                  this.setState({
                    isAvailableForDailyQuiz:
                      !this.state.isAvailableForDailyQuiz,
                  });
                }}
              />
              <label className="checkbox-inline ml-10">
                Disabled for daily quiz
              </label>
            </div>
          ) : null}
        </div>
        {isRate ? (
          <div className="form-group row">
            <div className="col-md-12">
              <input
                type="checkbox"
                value="isPfeOnly"
                name="isPfeOnly"
                checked={this.state.isPfeOnly}
                onChange={() => {
                  this.setState({ isPfeOnly: !this.state.isPfeOnly });
                }}
              />
              <label className="checkbox-inline ml-10">PFE Only</label>
            </div>
          </div>
        ) : (
          ''
        )}
        {isRate ? (
          <div className="form-group row">
            <div className="col-md-12">
              <input
                type="checkbox"
                value="hasPassword"
                name="hasPassword"
                checked={this.state.hasPassword}
                onChange={() => {
                  this.setState({ hasPassword: !this.state.hasPassword });
                }}
              />
              <label className="checkbox-inline ml-10">
                Remove from pricing page
              </label>
            </div>
          </div>
        ) : (
          ''
        )}
        {isRate && this.state.hasPassword ? (
          <div className="form-group row">
            <div className="col-md-12">
              <input
                className="form-control"
                placeholder="Password"
                value={this.state.password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </div>
          </div>
        ) : (
          ''
        )}
        {isRate ? <div className="separatorLine width-auto" /> : ''}
        {isRate && !this.state.isPfeOnly && !this.state.isDisabled && (
          <div className="form-group row form-group-marginTop">
            <div className="individualExam-contianer">
              <span className="individualExam-text">
                Selecting each individual exam, it will disabled
              </span>
            </div>
            {VALID_RANKS.map((rank) => {
              const examKey = `${rank.toLowerCase()}_regular`;
              const examExists = this.props.selectedSP[examKey] !== undefined;

              return (
                <div className="col-md-4" key={rank}>
                  {examExists ? (
                    <input
                      type="checkbox"
                      value={examKey}
                      name={examKey}
                      checked={this.state[examKey]}
                      onChange={() => {
                        this.setState({ [examKey]: !this.state[examKey] });
                      }}
                    />
                  ) : null}
                  <label className="checkbox-inline ml-10">
                    {examExists ? rank : 'No exam'}
                  </label>
                </div>
              );
            })}
          </div>
        )}
      </Row>
    );
  };

  deleteSP = () => {
    this.props.openModal({
      modalTitle: `Deleting : ${this.props.selectedSP.name}`,
      modalContent: (
        <ConfirmDeletion
          text={<span>Enter the word DELETE to confirm deletion.</span>}
          onSubmit={() => {
            this.props.closeModal();
            this.props.onDelete(this.props.selectedSP);
          }}
          onCancel={this.props.closeModal}
        />
      ),
    });
  };

  onSave = () => {
    const state = this.state;
    state.isQual = this.state.type === 'qual';
    if (!state.hasPassword) {
      state.password = null;
    }

    const filtered = {};
    for (const key in state) {
      if (key in this.props.selectedSP) {
        filtered[key] = state[key];
      }
    }
    if (filtered) {
      filtered.isQual = this.state.type === 'qual';
    }

    if (state.id) {
      this.props.onEdit(filtered);
    } else {
      this.props.onCreate(state);
    }
  };

  getCardFooter = (canManage) => {
    if (!canManage) {
      return null;
    }

    return (
      <Row className="cardFooterWrapper" style={{ justifyContent: 'flex-end' }}>
        <div className="bottom-buttons">
          <Button
            type="submit"
            className="btn-success btn-success-roles"
            loading={this.props.creating || this.props.updating}
            onClick={this.onSave}
          >
            Save
          </Button>
          {this.props.selectedSP.id && (
            <Button
              onClick={this.deleteSP}
              loading={this.props.isDeleting}
              className="btn btn-danger btn-cancel-roles"
            >
              Delete
            </Button>
          )}
        </div>
      </Row>
    );
  };

  getTitle = (sp) => {
    if (sp.id) {
      return sp.name;
    }
    return `New ${sp.type === 'rate' ? 'AFSC' : 'qual'}`;
  };

  render() {
    const { permissions = [] } = this.props;
    const isRate = this.props.selectedSP.type === 'rate';

    const canManage = isRate
      ? canPerformAction('Settings.AFSCs.Manage', permissions)
      : false;

    return (
      <Row style={{ width: '100%', margin: 0 }}>
        <Col
          style={{ padding: '20px', maxWidth: '480px', minWidth: '320px' }}
          md={9}
        >
          <Card
            title={this.getTitle(this.props.selectedSP)}
            content={this.renderContent()}
            footer={this.getCardFooter(canManage)}
          />
        </Col>
      </Row>
    );
  }
}

export default addAbilityToOpenModal(StudyProgramsDetails);
